export function maxLengthF(control: AbstractControl) {
  if (control.value.length > 15) {
    return { invalidName: true }
  }
  return null
}

export function maxLengthL(control: AbstractControl) {
  if (control.value.length > 20) {
    return { invalidName: true }
  }
  return null
}
import { AbstractControl } from '@angular/forms';

export function ValidateName(control: AbstractControl) {

  const value = control.value?.trim();
  let format = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
  let numbers = /^([^0-9]*)$/
  if (value.length == 0) {
    return { noCharacter: true }
  }
  if (value.charAt(0) === '-') {
    return { startsWithHyphen: true };
  }

  // Rule 3: First character cannot be an apostrophe
  if (value.charAt(0) === "'") {
    return { startsWithApostrophe: true };
  }

  if (format.test(control.value) || !numbers.test(control.value)) {
    return { invalidName: true };
  }
  if (spaceValidation(control.value)) {
    return { invalidName: true };
  }
  function spaceValidation(value) {
    let name = value.trim();
    if (!name) {
      return true;
    }
    return false;

  }
  if (value.length < 2 && value.length > 0) {
    return { minLength: true };
  }
  return null;
}